class Timer {
    #timerId: number | null;
    #start: Date;
    #remaining: number;
    #callback: () => void;

    constructor(callback: () => void, delay: number) {
        this.#timerId = null;
        this.#start = new Date();
        this.#remaining = delay;
        this.#callback = callback;
        this.resume();
    }

    pause() {
        if (this.#timerId !== null) {
            window.clearTimeout(this.#timerId);
        }
        this.#remaining -= new Date().getTime() - this.#start.getTime();
    }

    resume() {
        this.#start = new Date();
        if (this.#timerId !== null) {
            window.clearTimeout(this.#timerId);
        }
        this.#timerId = window.setTimeout(this.#callback, this.#remaining);
    }

    cancel() {
        if (this.#timerId !== null) {
            window.clearTimeout(this.#timerId);
        }
    }
}

export default Timer;
